import { tsValidateArray, tsValidateBoolean, tsValidateDynamicObject, tsValidateNumber, tsValidateOptionalId, tsValidateRange, tsValidateRegexp, tsValidateTimeRange, tsValidateUniqueId, tsValidateValue, tsValidator_nonMandatoryString, tsValidator_valueByKey } from '@nu-art/ts-common';
import { ListOf_VariableTypes, valueType_EnumElement, valueType_Enumerated, valueType_Range, valueType_StandardRange, valueType_SubEnumerated, valueType_SubRange, valueType_SubTime, valueType_Time, valueType_TimeRange, valueType_Tuple } from './consts.js';
import { knowledgeManagerDBGroup } from '../common.js';
const labelValidator = tsValidateRegexp(/^[A-Za-zÀ-ÖØ-öø-ÿ\d><=\-+'%:.&/ ]{2,100}$/, false);
const validator_subEnumerated = {
    value: labelValidator
};
const validator_range = {
    subsets: tsValidateArray(tsValidateUniqueId),
    unitsId: tsValidateOptionalId,
    scope: tsValidateRange(),
};
const validator_enumerated = {
    scope: tsValidateArray(tsValidateUniqueId),
    subsets: tsValidateArray(tsValidateUniqueId),
    props: {
        isOrdered: tsValidateBoolean(false),
        isExclusive: tsValidateBoolean(false)
    },
};
const validator_subEnumeratedData = {
    scope: tsValidateArray(tsValidateUniqueId),
    parentId: tsValidateOptionalId,
    label: labelValidator,
};
const validator_TupleData = {
    scope: tsValidateArray(tsValidateUniqueId),
    length: tsValidateNumber()
};
const validator_normalRangeV2Data = {
    unitsId: tsValidateOptionalId,
    fullRange: tsValidateRange(),
    declarationVarIds: tsValidateArray(tsValidateUniqueId),
    normalValues: tsValidateArray({
        conditions: tsValidateDynamicObject(tsValidateUniqueId, tsValidateUniqueId),
        range: tsValidateRange()
    }),
};
const validator_subRangeData = {
    scope: tsValidateRange(),
    parentId: tsValidateOptionalId,
    label: tsValidator_nonMandatoryString,
};
const validator_timeData = {
    timeRanges: tsValidateArray(tsValidateUniqueId)
};
const validator_timeRangeData = {
    timeRange: tsValidateTimeRange()
};
const validator_subTime = {
    scope: tsValidateArray(tsValidateUniqueId),
    parentId: tsValidateOptionalId,
};
export const Validator_ValueData = {
    [valueType_EnumElement]: validator_subEnumerated,
    [valueType_SubRange]: validator_subRangeData,
    [valueType_SubEnumerated]: validator_subEnumeratedData,
    [valueType_Enumerated]: validator_enumerated,
    [valueType_Range]: validator_range,
    [valueType_Tuple]: validator_TupleData,
    [valueType_StandardRange]: validator_normalRangeV2Data,
    [valueType_Time]: validator_timeData,
    [valueType_TimeRange]: validator_timeRangeData,
    [valueType_SubTime]: validator_subTime,
};
const Validator_ModifiableProps = {
    type: tsValidateValue(ListOf_VariableTypes),
    data: tsValidator_valueByKey(Validator_ValueData),
    nlpDataId: tsValidateOptionalId,
    _rowId: tsValidateOptionalId,
    label: tsValidator_nonMandatoryString
};
const Validator_GeneratedProps = {
    __unitsId: tsValidateOptionalId,
    __valueIds: tsValidateArray(tsValidateUniqueId),
    __variableIds: tsValidateArray(tsValidateUniqueId),
};
export const DBDef_Value = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.1', '1.0.0'],
    dbKey: 'values',
    entityName: 'Value',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'value'
    },
    backend: {
        name: 'values'
    },
    dependencies: {
        __unitsId: { dbKey: 'measurement-units', fieldType: 'string' },
        __valueIds: { dbKey: 'values', fieldType: 'string[]' },
        __variableIds: { dbKey: 'variables', fieldType: 'string[]' },
    }
};
//# sourceMappingURL=db-def.js.map